import React from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

function Header({ title = 'DRIFT MARKETS' }) {
  return (
    <header className="header">
      <h1>{title}</h1>
      <nav className="nav">
        <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>
          Markets
        </NavLink>
        <NavLink to="/my-bets" className={({ isActive }) => isActive ? 'active' : ''}>
          My Bets
        </NavLink>
        <NavLink to="/admin" className={({ isActive }) => isActive ? 'active' : ''}>
          Admin
        </NavLink>
      </nav>
      <w3m-button />
    </header>
  );
}

export default Header;
